export default __webpack_public_path__ + "static/media/chevron_right_green.fbfb7bb0.svg";